<template>
  <div class="goods-cell-small" :class="{ shadow: showShadow }" @click="onTap">
    <div class="image-container">
      <img :src="item.thumbnailImg || item.spuImg || item.thumbnailUrl" class="goods-img" />
      <div v-if="item.inStock === 0" class="status-mask">
        <div class="status-circle">商品<br/>售罄</div>
      </div>
    </div>
    <div class="info-container">
      <div class="goods-name">{{ item.name }}</div>
      <div class="price-row">
        <span class="final-price">{{ item.finalPrice | currency(false) }}</span>
        <span v-if="item.singlePrice" class="single-price">
          {{ item.singlePrice | currency(false) }}{{ item.uom ? '/' + item.uom : '' }}
        </span>
      </div>
      <div class="tags-row">
        <span v-if="isStore && item.storeProfitPrice !== null" class="profit-tag-wrapper">
          <img src="@/assets/common/icon_earn.png" class="profit-icon-img" />
          <span class="earn-money-text">{{ item.storeProfitPrice | currency(false) }}</span>
        </span>
        <span v-if="item.activitySort && item.activitySort.includes('buyFree')" class="gift-tag">
          买赠
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoodsCellSmall",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isStore: {
      type: Boolean,
      default: false
    },
    showShadow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onTap() {
      this.$router.push({
        path: "/product/detail",
        query: { id: this.item.id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.goods-cell-small {
  width: 105px;
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  display: inline-block;
  vertical-align: top;
  margin-right: 8px;
  text-align: left;
  &.shadow {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
}
.image-container {
  width: 105px;
  height: 105px;
  position: relative;
  background-color: #f7f8fa;
  .goods-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.status-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.status-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.3;
}
.info-container {
  padding: 6px;
}
.goods-name {
  font-size: 12px;
  color: #333;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  margin-bottom: 4px;
}
.price-row {
  display: flex;
  align-items: baseline;
  margin-bottom: 2px;
  line-height: 1.2;
}
.final-price {
  font-size: 10px;
  color: #333;
  font-weight: bold;
  margin-right: 4px;
}
.single-price {
  font-size: 8px;
  color: #999;
  text-decoration: line-through;
  white-space: nowrap;
}
.tags-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-height: 15px;
  margin-top: 2px;
}
.profit-tag-wrapper {
  // display: inline-block;
  // vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profit-icon-img {
  width: 14px;
  height: 14px;
  object-fit: contain;
  margin-right: 3px;
  vertical-align: middle;
  display: inline-block;
}
.earn-money-text {
  color: #f81a27;
  font-weight: bold;
  font-size: 9px;
  vertical-align: middle;
  display: inline-block;
  line-height: 14px;
  margin-top:1px
}
.gift-tag {
  font-size: 9px;
  color: #fff;
  background-color: #ff976a;
  padding: 1px 4px;
  border-radius: 2px;
  font-weight: 500;
}
</style>
